// extracted by mini-css-extract-plugin
module.exports = {"selector":"PofsPage_selector__dpypJ"};